import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import StarIcon from "@mui/icons-material/Star";

export default function ForwardedFeaturedNotice({ title = "", avatarUrl = "" }) {
  const trimmedTitle = String(title || "").trim();

  return (
    <Box
      sx={(theme) => {
        const isDark = theme.palette.mode === "dark";
        const accent = isDark ? theme.palette.primary.light : theme.palette.primary.main;
        return {
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          px: 2,
          py: 1.5,
          mb: 2,
          borderRadius: 1,
          border: `1px solid ${alpha(accent, isDark ? 0.5 : 0.25)}`,
          backgroundColor: alpha(accent, isDark ? 0.16 : 0.06),
        };
      }}
    >
      <Avatar
        src={avatarUrl || undefined}
        alt=""
        sx={(theme) => ({
          width: 40,
          height: 40,
          bgcolor:
            theme.palette.mode === "dark"
              ? theme.palette.primary.light
              : theme.palette.primary.main,
          color: theme.palette.getContrastText(
            theme.palette.mode === "dark"
              ? theme.palette.primary.light
              : theme.palette.primary.main
          ),
        })}
      >
        <StarIcon fontSize="small" />
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          You&apos;re forwarding a featured capsule
        </Typography>
        <Typography
          variant="caption"
          sx={{ display: "block", color: "text.primary", opacity: 0.75 }}
        >
          {trimmedTitle ? `“${trimmedTitle}” — its` : "Its"} content, media, and
          offer will appear for your recipient after they sign in.
        </Typography>
      </Box>
    </Box>
  );
}
